module.exports = __webpack_public_path__ + "fonts/LTCCaymanGoudyModern-Regular.65f6ef58338edabb28df770c637baddf.woff";